import { map, range } from 'lodash';
import { COLOR_BACKGROUND_LIGHT } from '../../components/commander-ui/constants';
import { DASH_LENGTH, TICK_SIZE, X_AXIS_HEIGHT } from './constants';

const SUBLINES_MULTIPLIER = 2;

export const getVerticalLinePositions = ({ dataSize, xStartOffset = 0, xEndOffset = 0, chartWidth }: $TSFixMe) => {
    const start = xStartOffset as number;
    const end = chartWidth - xEndOffset;
    const width = end - start;
    const step = width / dataSize / SUBLINES_MULTIPLIER;
    const linesCount = dataSize * SUBLINES_MULTIPLIER + 1;
    return map(range(linesCount), (item) => start + step * item);
};

export const renderLineFactory =
    ({ yStartOffset = TICK_SIZE, yEndOffset = TICK_SIZE + X_AXIS_HEIGHT, chartHeight }: $TSFixMe = {}) =>
    (xPosition: $TSFixMe, index: $TSFixMe) => {
        const isDashed = index % SUBLINES_MULTIPLIER !== 0;
        const props = {
            key: xPosition,
            stroke: COLOR_BACKGROUND_LIGHT,
            x1: xPosition,
            x2: xPosition,
            y1: yStartOffset,
            y2: chartHeight - yEndOffset,
            strokeDasharray: isDashed ? `${DASH_LENGTH} ${DASH_LENGTH * 2}` : null,
        };
        // @ts-expect-error $TSFixMeError: Type '{ key: any; stroke: string; x1: any; x2: any; y1: any; y2: number; strokeDasharray: string | null; }' is not assig...
        return <line {...props} />;
    };
